module.exports = __webpack_public_path__ + "static/3e42c3e60844de0fabc656712dd6ad69.png";